import { GrowthBook } from '@growthbook/growthbook'
import { getGrowthbookConfig } from 'helpers/constants/growthbook-config'
import { getWebFunnelsConfig } from 'helpers/getWebFunnelsConfig'
import {
  isWalletMethodShown,
  setWalletUnavailable,
} from 'helpers/prefetchWalletPayment'
import { useEffect } from 'react'
import { CurrentEnvironment } from 'root-constants'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

let isGrowthbookInitializing = false

export const useInitGrowthbook = (): void => {
  const { leadId, cohort, country, growthbook } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id,
      cohort: state.lead?.cohort || state.initialCohort,
      country: state.lead?.country || '',
      growthbook: state.growthbook,
    })),
  )
  const language = useZustandSessionStore((state) => state.language)

  useEffect(() => {
    if (
      !leadId ||
      !cohort ||
      isGrowthbookInitializing ||
      useZustandStore.getState().growthbook
    ) {
      return
    }

    const initializeGrowthbook = async () => {
      isGrowthbookInitializing = true
      const { apiHost, clientKey } = getGrowthbookConfig()
      let growthbookInstance = new GrowthBook()

      try {
        growthbookInstance = new GrowthBook({
          apiHost,
          clientKey,
          enableDevMode:
            import.meta.env.CURRENT_ENV !== CurrentEnvironment.PROD,
          attributes: {
            id: leadId,
            leadId,
            country,
            cohort,
            language,
          },
        })
        await growthbookInstance.init({ timeout: 2000 })
      } catch (err) {
        console.warn(err)
      } finally {
        isGrowthbookInitializing = false
      }

      useZustandStore.setState({ growthbook: growthbookInstance })

      if (!isWalletMethodShown(getWebFunnelsConfig(growthbookInstance))) {
        setWalletUnavailable()
      }
    }

    void initializeGrowthbook()
  }, [leadId, cohort, country, language])

  useEffect(() => {
    if (!growthbook || !leadId) return

    growthbook.setAttributes({
      id: leadId,
      leadId,
      country,
      cohort,
      language,
    })
  }, [growthbook, leadId, country, cohort, language])
}
